import withStyles from '@mui/styles/withStyles';

import styles from './styles';

const IllustrationSkeleton = ({ classes = {}, style = {} }) => (
  <div style={style} className={classes.illustration} />
);

export default withStyles(styles)(IllustrationSkeleton);
